module.exports = __webpack_public_path__ + "static/img/AppBannerNyg.c69a7b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/AppBannerNyg.png
// module id = OJQP
// module chunks = 1